<template>
    <div class="body">
        <div class="filter">
            <el-row :gutter="20" class="mb20">
                <el-col :span="6">
                    <div class="filter-col">
                        <label>用户名</label>
                        <el-input v-model="params.username" placeholder="请输入用户名" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="6" :offset="2">
                    <div class="filter-col">
                        <label>姓名</label>
                        <el-input v-model="params.personalName" placeholder="请输入姓名" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="6" :offset="2">
                    <div class="filter-col">
                        <label>联系方式</label>
                        <el-input v-model="params.phone" placeholder="请输入联系方式" clearable></el-input>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="mb20" v-show="roleList.length > 0">
                <el-col :span="6">
                    <div class="filter-col">
                        <label>角色</label>
                        <el-select v-model="params.roleId" placeholder="请选择角色" clearable>
                            <el-option label="全部角色" :value="null"></el-option>
                            <el-option
                                    v-for="item in roleList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="6" :offset="2">
                    <div class="filter-col">
                        <label>状态</label>
                        <el-select v-model="params.enabled" placeholder="请选择状态" clearable>
                            <el-option label="全部状态" :value="null"></el-option>
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="冻结" value="0"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <div class="flex-end">
                    <el-button type="primary" @click="handleSearch"
                               v-show="allowAction.indexOf('view') != -1">查询</el-button>
                </div>
            </el-row>
        </div>
        <div class="data-box">
            <div class="modify-box">
                <el-button class="modify-button" type="primary" @click="handleAdd"
                           v-show="allowAction.indexOf('create') != -1">新建</el-button>
            </div>
            <div class="list-box">
                <el-table
                        :data="list"
                        stripe
                        style="width: 100%">
                    <el-table-column
                            label="用户ID"
                            prop="id"
                            align="center"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            label="用户名"
                            prop="username"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="姓名"
                            prop="personalName"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="联系方式"
                            prop="phone"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="角色"
                            prop="roleName"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="状态"
                            prop="enabled"
                            align="center"
                            :formatter="formatStatus"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            label="创建时间"
                            prop="createTime"
                            align="center"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            align="center"
                            fixed="right"
                            min-width="180"
                            v-if="optionStatus"
                    >
                        <template slot-scope="scope">
                            <div class="flex-center flex-middle">
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        @click="handleEdit(scope.row)"
                                        v-show="allowAction.indexOf('edit') != -1"
                                >编辑</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        style="color: #669900"
                                        v-if="scope.row.enabled === 1"
                                        @click="handleDisable(scope.row.id)"
                                        v-show="allowAction.indexOf('enable') != -1"
                                >冻结</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        style="color:#F56C6C;"
                                        v-else
                                        @click="handleEnable(scope.row.id)"
                                        v-show="allowAction.indexOf('enable') != -1"
                                >解冻</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        @click="handleResetPassword(scope.row.id)"
                                        v-show="allowAction.indexOf('password.reset') != -1"
                                >重置密码</el-button>
                                <el-button
                                        class="btn-style"
                                        size="mini"
                                        type="text"
                                        style="color: #F56C6C"
                                        @click="handleDelete(scope.row)"
                                        v-show="allowAction.indexOf('delete') != -1"
                                >删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <!--分页-->
                <div class="t_m m10">
                    <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            :current-page.sync="params.pageNum"
                            :page-size="params.pageSize"
                            layout="total, prev, pager, next"
                            :total="pageTotal">
                    </el-pagination>
                </div>
            </div>
        </div>

        <AddAccountDialog v-on:fetchData="fetchData" ref="AddAccountDialog"></AddAccountDialog>
    </div>
</template>

<script>
    import AddAccountDialog from './components/AddAccountDialog.vue'
    import Utils from '@/assets/js/Utils'

    export default {
        name: 'AccountManage',
        components: {AddAccountDialog},
        data() {
            return {
                allowAction: [],
                optionStatus: true,
                params: {
                    orderBy: null,
                    pageNum: 1,
                    pageSize: 5,
                    username: null, // 用户名
                    personalName: null, //
                    phone: null,
                    roleId: null,
                    enabled: null,
                },
                list: [],

                pageTotal: null,

                roleList: [],
            }
        },
        mounted(){
            this.fetchData()
            this.allowAction = Utils.checkMenuOprate('system.account')
            for(let i = 0;i<this.allowAction.length; i++) {
                let item = this.allowAction[i]
                if(item != 'view' && item != 'create') {
                    this.optionStatus = true
                    return
                }
            }
            this.optionStatus = false
        },
        methods: {

            formatStatus(val) {
                return val.enabled===1?'正常':'冻结'
            },

            handleCurrentChange(val) {
                this.params.pageNum = val
                this.fetchData()
            },

            handleSearch() {
                this.fetchData()
            },

            fetchData() {
                axios.get(Urls.URL.account_url,{params:this.params}).then(res => {
                    if(res.status == '200') {
                        this.list = res.data.data.rows
                        this.pageTotal = res.data.data.count
                    }
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
                // 查询是否有查看角色权限
                let allowAction = Utils.checkMenuOprate('system.role')
                if(allowAction&& allowAction.length > 0 && allowAction.indexOf('view') != -1) {
                    axios.get(Urls.URL.role_url,{params:{pageSize:1000,pageNum:1}}).then(res => {
                        if(res.status == '200') {
                            this.roleList = res.data.data.rows
                        }
                    }).catch(err => {
                        this.$alert(err.response.data.errorMessage || Utils.errorText)
                    })
                }
            },

            handleAdd() {
                this.$refs.AddAccountDialog && this.$refs.AddAccountDialog.setMaskVisible(true, {});
            },

            handleEdit(data) {
                this.$refs.AddAccountDialog && this.$refs.AddAccountDialog.setMaskVisible(true, data);
            },

            handleDisable(id) {
                axios.post(Urls.URL.account_url+'/'+id+'/disable').then(res => {
                    this.fetchData()
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleEnable(id) {
                axios.post(Urls.URL.account_url+'/'+id+'/enable').then(res => {
                    this.fetchData()
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleResetPassword(id) {
                axios.post(Urls.URL.account_url+'/'+id+'/password/reset').then(res => {
                    this.fetchData()
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleDelete(data) {
                this.$confirm(`用户“${data.personalName}”正在被删除，是否确定`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.delete(Urls.URL.account_url+'/'+data.id).then(res => {
                        this.fetchData()
                    }).catch(err => {
                        this.$alert(err.response.data.errorMessage || Utils.errorText)
                    })
                }).catch(() => {
                    return
                });
            },

        }
    }
</script>

<style scoped lang="stylus">
    .body {
        width 100%
        height 100%
        padding-top 20px
    }

    .filter {
        padding 20px
        flex 1
        background-color white
        margin-bottom 20px
        .filter-col {
            display flex
            align-items center
            >label {
                width 15%
                min-width 80px
            }
            >.el-input {
                flex 1
                min-width 120px
            }
            >.el-select {
                flex 1
                min-width 120px
            }
        }
    }


    .data-box {
        flex 1
        background-color white
        .modify-box {
            flex 1
            height 80px
            padding 0 20px
            display flex
            align-items center
            .modify-button {
                width 100px
            }
        }
        .list-box {
            flex 1
            padding 0 25px
        }
    }

    .mb20 {
        margin-bottom 20px
    }

    .flex-end {
        flex 1
        display flex
        justify-content flex-end
        padding-right 20px
    }
</style>